module.exports = __webpack_public_path__ + "img/icon_email_bind_step_first.72ad315a.png";